import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'isEventInTimeRange',
})
export class IsEventInTimeRangePipe implements PipeTransform {
  transform(events: any, from: number, to: number): any {
    const temp = <any>[];

    events.map((event: any) => {
      if (event.minStartTime >= from && event.minStartTime < to) {
        temp.push(event);
      }
    });

    return temp;
  }
}
